<div
  class="filter-buttons gap-x-2"
  [ngClass]="{ 'position-right': position === 'right', 'is-mobile': mobile }"
>
  <app-shared-button
    theme="tertiary"
    #resetButton
    (click)="handleReset(resetButton)"
  >
    {{ mobile ? 'Clear all' : 'Reset' }}
  </app-shared-button>

  <app-shared-button #applyButton (click)="handleApply(applyButton)">
    Apply
  </app-shared-button>
</div>
